export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11056.76d151c3.jpg";